import { useTrackEventForAdoption } from "src/query/adoption";
import { TrackEventForAdoptionRequest } from "src/types/adoption";
import {
  TRACK_CUSTOM_FIELD_CLICKED_EVENT,
  TRACK_CUSTOM_FIELD_CREATED_EVENT,
} from "src/redux/actions/actionTypes";
import { CustomField } from 'src/types/settings/customFields';
import _ from "lodash";
import { SettingsModule } from "src/types/settings/common";

export const useCustomFieldTracking = () => {
  const { mutate: trackEvent } = useTrackEventForAdoption(SettingsModule.CUSTOM_FIELDS);

  const trackCustomFieldClicked = () => {
    const event = {
      event: TRACK_CUSTOM_FIELD_CLICKED_EVENT,
      properties: {},
    };
    trackEvent(event);
  };

  const trackCustomFieldCreated = (item: CustomField) => {
    const field_name = _.get(item, 'name', '');
    const help_text = _.get(item, 'helpText', '');
    const values = _.get(item, 'options', []).map((option: any) => option.value);
    const isMultiSelectAllowed = _.get(item, 'multiselect', false) ? 'Yes' : 'No';
    const isShowInSearchPage = _.get(item, 'searchable', false) ? 'Yes' : 'No';

    const data: TrackEventForAdoptionRequest = {
      event: TRACK_CUSTOM_FIELD_CREATED_EVENT,
      properties: {
        field_name,
        help_text,
        values,
        isMultiSelectAllowed,
        isShowInSearchPage,
      },
    };
  
    trackEvent(data);
  };

  return {
    trackCustomFieldClicked,
    trackCustomFieldCreated,
  };
};
